import { BBreadcrumb } from './breadcrumb';
import { BBreadcrumbItem } from './breadcrumb-item';
import { BBreadcrumbLink } from './breadcrumb-link';
import { pluginFactory } from '../../utils/plugins';
var BreadcrumbPlugin = /*#__PURE__*/pluginFactory({
  components: {
    BBreadcrumb: BBreadcrumb,
    BBreadcrumbItem: BBreadcrumbItem,
    BBreadcrumbLink: BBreadcrumbLink
  }
});
export { BreadcrumbPlugin, BBreadcrumb, BBreadcrumbItem, BBreadcrumbLink };


//////////////////
// WEBPACK FOOTER
// ./~/.pnpm/bootstrap-vue@2.23.1_jquery@3.7.1_vue@2.6.14/~/bootstrap-vue/esm/components/breadcrumb/index.js
// module id = +jPP
// module chunks = 5